// Sliders
import './sliders';

// Animations
import './animations';

// Who we are script
import './_who-we-are';